var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cummode_box"},_vm._l((_vm.videoList),function(item,index){return _c('div',{key:index,staticClass:"cun_inner"},[_c('div',{attrs:{"id":'video' + index}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }